import React, { useEffect, useState } from "react";
import Section from "../../../components/Section";
import { pageTitle } from "../../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../../components/SecondaryButton";
import PageHeader from "../../../components/PageHeader";
import axiosInstance from "../../../utils/axiosInstance";
import { fetchDoctorCategories, fetchDoctorProfile, imageBaseUrl, registerUser, updateDoctorDetails, updateUserDetais } from "../../../constants/ApiConstants";
import { useNavigate } from "react-router-dom";
import { updateUserData, updateDoctorData } from "../../../store/appSlice";
import { FaX } from "react-icons/fa6";
import FullPageLoader from "../../../components/FullPageLoader";
import ListEmptyText from "../../../components/ListEmptyText";
import { primaryColor, surfaceColor3 } from "../../../constants/colors";
import CommonMobileHeader from "../../../components/Header/CommonMobileHeader";

export default function DoctorCategories() {
  pageTitle("Select a category");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData)?.id;
  const [doctorDetail, setDoctorDetail] = useState("");
  const [categories, setCategories] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [searchTerm, setSearchText] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchCategories();
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);

    axiosInstance
      .post(fetchDoctorProfile, { doctor_id: doctorId })
      .then((res) => {
        setDoctorDetail(res?.data?.data);
        setCategoryId(res.data?.data?.category_id);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  function fetchCategories() {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorCategories)
      .then((res) => setCategories(res.data.data))
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const handleSubmitClick = async () => {
    if (!categoryId) {
      toast.error("Please choose a category");
      return;
    }
    const payload = {
      doctor_id: doctorId,
      category_id: categoryId,
    };
    try {
      setSubmitting(true);
      const response = await axiosInstance.post(updateDoctorDetails, {
        ...payload,
      });
      if (response.data?.status) {
        toast.success("Doctor details has been updated.");
        dispatch(updateDoctorData(response?.data?.data));
        navigate(-1);
      } else {
        toast.error(response.data?.message);
      }
      setSubmitting(false);
    } catch (err) {
      console.log(err);
      // toast.error(err.response.data?.message);
      setSubmitting(false);
    }
  };

  const onCategorySelect = (cat) => {
    setCategoryId(cat.id);
  };
  const onSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const getFilteredCats = () => (searchTerm === "" ? [...categories] : categories?.filter((it) => it.title.includes(searchTerm)));

  return (
    <Wrapper>
      <Section bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading && !categories ? (
          <FullPageLoader />
        ) : (
          <div className="content-wrapper d-flex flex-column p-3 gap-1 align-items-center justify-content-center">
            <CommonMobileHeader canBack={true} title={"My Category"} />
            <div className="col-sm-6 col-md-6 g-2 ">
              <p className="m-2 text-dark">Select Your category</p>
              <div className="d-flex bg-grey2 w-100 rounded-pill position-relative">
                <input type="text" placeholder="Search" className="fs-normal bg-transparent border-0 px-3 py-2 text-black w-75" value={searchTerm} onChange={onSearchChange} />
                {searchTerm !== "" && (
                  <button onClick={() => setSearchText("")} type="button" className="d-flex justify-content-center align-items-center position-absolute bg-grey1" style={{ right: 8, height: 28, width: 28, borderRadius: 100, top: "15%" }}>
                    <FaX color="#000" size={13} />
                  </button>
                )}
              </div>
              <p className="fs-md text-grey2 p-2"></p>
              {!loading && categories?.length === 0 && <ListEmptyText text="Categories Not Available." />}
              {!loading && categories?.length > 0 && (
                <div className="row mb-2">
                  {getFilteredCats()?.map((cat) => (
                    <div key={cat.id} className="col-6 col-md-6 col-sm-6 col-lg-4 py-1 px-2" onClick={() => onCategorySelect(cat)} style={{ cursor: "pointer" }}>
                      <div className="d-flex flex-column gap-1 py-3 px-3 rounded justify-content-around" style={{ background: categoryId === cat.id ? primaryColor : `${surfaceColor3}`, height: "100px" }}>
                        <img className="img-fluid" src={`${imageBaseUrl}${cat.image}`} alt="" style={{ height: 28, width: 28, borderRadius: 100 }} />
                        <strong className={`${categoryId === cat.id ? "text-white" : "text-sprimary"} fs-sm`} style={{ lineHeight: "1.2" }}>
                          {cat.title}
                        </strong>
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <SecondaryButton title={"Submit"} className={"mt-3 floating-btn"} onClick={handleSubmitClick} loading={submitting} />
            </div>
          </div>
        )}
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  @media screen and (max-width: 768px) {
    /* .floating-btn {
      position: fixed;
      left: 0;
      right: 0;
      z-index: 1000;
      height: 60px;
    } */
  }
`;
